export default "__VITE_ASSET__X3MgXVic__"